export const pagesToUse = [
    '/community-podcasts',
    '/resources/content',
    '/articles',
    '/career-topics',
    '/jobs/find',
];